import React from 'react';

const InputButton = () => {
    return (
        <div>
            Input Button
        </div>
    );
};

export default InputButton;